(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3014],{

/***/ 72522:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/group-purchase",
      function () {
        return __webpack_require__(90947);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 90947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64384);
/* harmony import */ var _components_group_event_GroupEventLayout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20660);
/* harmony import */ var _redux_action_loading__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19828);
/* harmony import */ var _redux_action_confirm__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94184);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);






var GroupPurchasePage = function(param) {
    var siteConfig = param.siteConfig, _$isLoaded = param.isLoaded, _$isLoading = param.isLoading, _$openConfirmModal = param.openConfirmModal, _$modifyConfirmModal = param.modifyConfirmModal, _$closeConfirmModal = param.closeConfirmModal;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_group_event_GroupEventLayout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            parent: "\uD648",
            subChild: "\uACF5\uB3D9 \uAD6C\uB9E4",
            code: siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.Purchase
        })
    });
};
var mapDispatchToProps = {
    isLoading: _redux_action_loading__WEBPACK_IMPORTED_MODULE_4__/* .isLoading */ .h,
    isLoaded: _redux_action_loading__WEBPACK_IMPORTED_MODULE_4__/* .isLoaded */ .k,
    openConfirmModal: _redux_action_confirm__WEBPACK_IMPORTED_MODULE_5__/* .openConfirmModal */ ._5,
    modifyConfirmModal: _redux_action_confirm__WEBPACK_IMPORTED_MODULE_5__/* .modifyConfirmModal */ .sR,
    closeConfirmModal: _redux_action_confirm__WEBPACK_IMPORTED_MODULE_5__/* .closeConfirmModal */ .d6
};
/* harmony default export */ __webpack_exports__["default"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .connect */ .$j)(null, mapDispatchToProps)(GroupPurchasePage));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,9199,4231,7533,2511,4027,4754,7503,5582,660,9774,2888,179], function() { return __webpack_exec__(72522); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);